import React from 'react';
import Main from '../../components/Main';
import { useNavigate } from 'react-router-dom';
import {Row, Col, Image, Button } from 'react-bootstrap';
import LongCard from '../../components/LongCard';
import RegisterForm from '../../components/RegisterForm';
import register from '../../assets/images/register.png';
import '../../assets/styles/Global.css';

// IQosystem Subpage of AboutUs Page

const images = {};

function importAll(r) {
  r.keys().forEach((key) => {
    images[key.replace('./', '')] = r(key);
  });
}


// Imports all images from the iqosystem folder into the images array

importAll(require.context('../../assets/images/aboutus_icons/iqosystem', false, /\.(png|jpe?g|svg)$/));

const iqosystem_l = [
  {
    title: "Share qualified leads",
    description: "Earn commissions and/or equity for each project",
    details : `As an IQosystem partner, you can contribute to value creation, sharing leads of executives requiring advisory services, and earning commissions on business generated. The IQosys app allows you to view the detailed status of all your leads, track progress and commission payments.

    It’s a system built for trust, that enables control.`,
    icon:images['iqosystem_1.png'],
  },
  {
    title: "Sponsor qualified consultants",
    description: "Earn bonus payments based on consultants’ performance",
    details : `You can also refer qualified consultants for projects that IQosys is staffing and earn commissions, all while tracking your consultant’s progress through your IQosys account for full transparency.`,
    icon: images['iqosystem_2.png'],
  },
  {
    title: "Earn IQosys shares",
    description: "Become a valued shareholder and partner",
    details : `Each successful contribution gives you access rights to IQosys equity (see
    IQS Tokens), complementing your revenues and clearing the path for you to become a fully fledged, valued stakeholder in the business.`,
    icon: images['iqosystem_3.png'],
  },
];

const IQosystem = () => {
  const navigate = useNavigate();
  const handleRegisterClick = () => {
    navigate('/myaccount/register'); // Redirect to the Register page
  };

  return (
    <div>
      <Main componentList={[
        <h6 className='top_sentence'>Join our IQosystem and participate in value creation … when and where it suits YOU</h6>,
        <h7>Join the IQosys network and unlock unique opportunities without committing to full-time
        or even part-time work.</h7>,
        <Col className="mt-4">
          {iqosystem_l.map((iqosystem, index) => (
            <Row md={6} lg={1} key={index}>
              <LongCard className="h-100 shadow-sm" longcard={iqosystem}/>
            </Row>
          ))}
        </Col>,
        <h7>Apply to join our IQosystem network now! An IQosys representative will contact you to discuss your fit and if our values are aligned, will formalize the partnership with a contract.</h7>,
        <hr className="my-custom-hr"/>,
        <Button variant="light" 
          className="mt-auto btn-sm text-start align-self-start border-0"  
          onClick={handleRegisterClick}
          style={{ 
            backgroundColor: "white", 
            boxShadow: "none",
          }}
        >
          <div className="d-flex align-items-center" style={{marginBottom:"10px"}}>
            <Image src={register} width={32} height={32} alt="Register Icon" />
            <span className='ms-2' style={{color: "#7300FF", fontWeight: "bold"}}>Apply to join</span>
          </div>
        </Button>
        ]} />
    </div>
  );
};

export default IQosystem;